import StopLabel from "./StopLabel";
import { sortBy } from 'lodash';

const getStopsList = (stops) => {
  return sortBy(
    stops.map((stop) => ({
      label: <StopLabel stop={stop} />,
      value: stop.stopId,
      isStopCompleted: stop.isStopCompleted,
      stopSequence : stop.stopSequence
    })),
    "stopSequence"
  );
};

const getProImagesCount = (proId,proData) => {
  const { proImages = {} } = proData?.find((pro) => pro.proId === proId) ?? {};
  return Object.keys(proImages).reduce((acc,key)=>{
    return acc + proImages[key]?.length
  },0)
}

const base64toBlob = (data, sliceSize = 512) => {
  const byteCharacters = atob(data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: 'application/pdf' });
};

export { getStopsList, getProImagesCount, base64toBlob };
